import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnifiedSearchPage from '../../components/common/UnifiedSearchPage';
import { fetchEfforts } from '../../services/dataService';
import usePageTitle from '../../utils/usePageTitle';

const Effort = () => {
  usePageTitle('Effort');
  const navigate = useNavigate();
  
  const getRowLink = (row) => `/effort/detail/${row.projectCode}`;

  const handleRowClick = (row) => {
    navigate(getRowLink(row));
  };

  const columns = [
    { key: 'projectCode', label: 'Project Code' },
    { key: 'budgetCode', label: 'Budget Code' },
    { key: 'requestorName', label: 'Requestor Name' },
    { key: 'personInCharge', label: 'Person In Charge' },
    { key: 'modelName', label: 'Model Name' },
    { key: 'projectStatus', label: 'Project Status' }
  ];

  return (
    <UnifiedSearchPage
      title="Effort"
      columns={columns}
      onRowClick={handleRowClick}
      getRowLink={getRowLink}
      loadDataFunction={fetchEfforts}
    />
  );
};

export default Effort;